import {FieldErrors} from "react-hook-form";

import {IAppError} from "@pg-mono/request-state";

import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {collectLeadFormFieldErrorPaths} from "./collect_lead_form_field_error_paths";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadFormProducts, IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

interface IAmplitudeLeadFormErrorBaseParams {
    trackingContext: IAmplitudeLeadFormTrackingContext;
    leadData: IAmplitudeLeadFormProductData;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    ctaText?: string;
}

export type IGetAmplitudeLeadFormErrorEventPropertiesParams = IAmplitudeLeadFormErrorBaseParams &
    ({appError: IAppError; fieldErrors?: never} | {fieldErrors: FieldErrors; appError?: never});

const buildErrorMessage = (appError: IAppError): string => {
    const fieldMessages = Object.values(appError.fieldErrors).flat();
    const parts = [...fieldMessages, ...appError.nonFieldErrors].filter(Boolean);

    return parts.length > 0 ? parts.join("; ") : `HTTP ${appError.status}`;
};

/** Field-level or typical 400 validation → `validation`; other failures → `server`. */
export const getAmplitudeLeadFormErrorType = (appError: IAppError): "validation" | "server" => {
    const hasFieldErrors = Object.keys(appError.fieldErrors).length > 0;

    if (hasFieldErrors || appError.status === 400) {
        return "validation";
    }

    return "server";
};

const getAmplitudeLeadFormErrorSharedProperties = (params: IAmplitudeLeadFormErrorBaseParams) => {
    const {trackingContext, leadData, source, sourceSection, ctaText} = params;
    const products = getAmplitudeLeadFormProducts(leadData);
    const resolvedCtaText = ctaText !== undefined ? ctaText : trackingContext.cta_text;

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        ...(resolvedCtaText ? {cta_text: resolvedCtaText} : {}),
        form_location: getAmplitudeFormLocation(leadData, trackingContext.form_location),
        source_id: trackingContext.source_id,
        lead_type: getAmplitudeLeadType(sourceSection),
        PRODUCTS: products,
        ...(trackingContext.promotion_id != null && {promotion_id: trackingContext.promotion_id}),
        ...(trackingContext.creative_name && {creative_name: trackingContext.creative_name}),
        ...(trackingContext.promotion_name && {promotion_name: trackingContext.promotion_name}),
        ...(trackingContext.promotion_content && {promotion_content: trackingContext.promotion_content})
    };
};

export const getAmplitudeLeadFormErrorEventProperties = (params: IGetAmplitudeLeadFormErrorEventPropertiesParams) => {
    const shared = getAmplitudeLeadFormErrorSharedProperties(params);

    if (params.appError) {
        return {
            ...shared,
            error_type: getAmplitudeLeadFormErrorType(params.appError),
            error_message: buildErrorMessage(params.appError),
            error_fields: Object.keys(params.appError.fieldErrors),
            error_code: String(params.appError.status)
        };
    }

    const {errorFields, errorMessages} = collectLeadFormFieldErrorPaths(params.fieldErrors);

    return {
        ...shared,
        error_type: "validation" as const,
        error_message: errorMessages.length > 0 ? errorMessages.join("; ") : "validation failed",
        error_fields: errorFields,
        error_code: "validation"
    };
};
import {FieldErrors} from "react-hook-form";

import {IAppError} from "@pg-mono/request-state";

import {IAmplitudeLeadFormTrackingContext} from "../../types/lead/IAmplitudeLeadFormEventTracking";
import {ApplicationSource, ApplicationSourceSection} from "../../utils/form/application_form_source";
import {collectLeadFormFieldErrorPaths} from "./collect_lead_form_field_error_paths";
import {getAmplitudeFormLocation} from "./get_amplitude_form_location";
import {getAmplitudeInquirySource} from "./get_amplitude_inquiry_source";
import {getAmplitudeLeadFormProducts, IAmplitudeLeadFormProductData} from "./get_amplitude_lead_form_products";
import {getAmplitudeLeadType} from "./get_amplitude_lead_type";

interface IAmplitudeLeadFormErrorBaseParams {
    trackingContext: IAmplitudeLeadFormTrackingContext;
    leadData: IAmplitudeLeadFormProductData;
    source: ApplicationSource;
    sourceSection: ApplicationSourceSection;
    ctaText?: string;
}

export type IGetAmplitudeLeadFormErrorEventPropertiesParams = IAmplitudeLeadFormErrorBaseParams &
    ({appError: IAppError; fieldErrors?: never} | {fieldErrors: FieldErrors; appError?: never});

const buildErrorMessage = (appError: IAppError): string => {
    const fieldMessages = Object.values(appError.fieldErrors).flat();
    const parts = [...fieldMessages, ...appError.nonFieldErrors].filter(Boolean);

    return parts.length > 0 ? parts.join("; ") : `HTTP ${appError.status}`;
};

/** Field-level or typical 400 validation → `validation`; other failures → `server`. */
export const getAmplitudeLeadFormErrorType = (appError: IAppError): "validation" | "server" => {
    const hasFieldErrors = Object.keys(appError.fieldErrors).length > 0;

    if (hasFieldErrors || appError.status === 400) {
        return "validation";
    }

    return "server";
};

const getAmplitudeLeadFormErrorSharedProperties = (params: IAmplitudeLeadFormErrorBaseParams) => {
    const {trackingContext, leadData, source, sourceSection, ctaText} = params;
    const products = getAmplitudeLeadFormProducts(leadData);
    const resolvedCtaText = ctaText !== undefined ? ctaText : trackingContext.cta_text;

    return {
        inquiry_source: getAmplitudeInquirySource(source),
        ...(resolvedCtaText ? {cta_text: resolvedCtaText} : {}),
        form_location: getAmplitudeFormLocation(leadData, trackingContext.form_location),
        source_id: trackingContext.source_id,
        lead_type: getAmplitudeLeadType(sourceSection),
        PRODUCTS: products,
        ...(trackingContext.promotion_id != null && {promotion_id: trackingContext.promotion_id}),
        ...(trackingContext.creative_name && {creative_name: trackingContext.creative_name}),
        ...(trackingContext.promotion_name && {promotion_name: trackingContext.promotion_name}),
        ...(trackingContext.promotion_content && {promotion_content: trackingContext.promotion_content})
    };
};

export const getAmplitudeLeadFormErrorEventProperties = (params: IGetAmplitudeLeadFormErrorEventPropertiesParams) => {
    const shared = getAmplitudeLeadFormErrorSharedProperties(params);

    if (params.appError) {
        return {
            ...shared,
            error_type: getAmplitudeLeadFormErrorType(params.appError),
            error_message: buildErrorMessage(params.appError),
            error_fields: Object.keys(params.appError.fieldErrors),
            error_code: String(params.appError.status)
        };
    }

    const {errorFields, errorMessages} = collectLeadFormFieldErrorPaths(params.fieldErrors);

    return {
        ...shared,
        error_type: "validation" as const,
        error_message: errorMessages.length > 0 ? errorMessages.join("; ") : "validation failed",
        error_fields: errorFields,
        error_code: "validation"
    };
};
